module.exports = __webpack_public_path__ + "img/Korean Meal-Chicken.912c508b.jpg";